import { createTheme } from '@mui/material';
import { esES } from '@mui/x-date-pickers/locales';

import {
  createComponents,
  createPalette,
  createShadows,
  createTypography,
} from '.';

export type ColorMode = 'light' | 'dark';

export const createAppTheme = (mode: ColorMode) => {
  const palette = createPalette(mode);
  const components = createComponents({ palette });
  const shadows = createShadows();
  const typography = createTypography();

  return createTheme(
    {
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 900,
          lg: 1200,
          xl: 1440,
        },
      },
      components: components as any,
      palette,
      shadows: shadows as any,
      shape: {
        borderRadius: 8,
      },
      typography: typography as any,
    },

    // locale
    esES
  );
};
